import React, { useState } from "react";
import Logo from "./bg-logo.png";

const MobileHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);

  const toggleSubmenu = (menu) => {
    setExpanded(expanded === menu ? null : menu);
  };

  return (
    <header className="mobile-header">
      <div className="top-bar">
        <img src={Logo} alt="Logo" className="mobile-logo" />
        <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>
      </div>

      {menuOpen && (
        <div className="side-menu">
          <button className="close-btn" onClick={() => setMenuOpen(false)}>
            ✕
          </button>
          <ul>
            <li>Home</li>
            <li>About Us</li>

            <li onClick={() => toggleSubmenu("courses")}>
              Courses ▾
              {expanded === "courses" && (
                <ul className="submenu">
                  <li>Web Development
                    <ul>
                      <li>MERN Stack</li>
                      <li>MEAN Stack</li>
                      <li>PHP & MySQL</li>
                      <li>React.js</li>
                      <li>Node.js</li>
                      <li>Angular</li>
                    </ul>
                  </li>
                  <li>Programming Languages
                    <ul>
                      <li>Python Fullstack</li>
                      <li>Java Fullstack</li>
                    </ul>
                  </li>
                  <li>Cadd Designs
                    <ul>
                      <li>Autocad</li>
                      <li>Catia</li>
                      <li>Solid Works</li>
                    </ul>
                  </li>
                </ul>
              )}
            </li>

            <li onClick={() => toggleSubmenu("trainings")}>
              Trainings ▾
              {expanded === "trainings" && (
                <ul className="submenu">
                  <li>Corporate Training
                    <ul>
                      <li>IT Companies</li>
                      <li>Mechanical Firms</li>
                      <li>Design Industries</li>
                    </ul>
                  </li>
                  <li>Industrial Training
                    <ul>
                      <li>Students</li>
                      <li>Internships</li>
                      <li>Workshops</li>
                    </ul>
                  </li>
                </ul>
              )}
            </li>

            <li>Contact Us</li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
